import * as tslib_1 from "tslib";
import * as React from 'react';
import * as dayjs from 'dayjs';
import TaskApi from '../../services/TaskApi';
import { List, ListItem, Divider } from 'material-ui';
import { cyan500, grey200 } from 'material-ui/styles/colors';
var styles = {
    textRight: {
        backgroundColor: grey200,
        borderRadius: '3px',
        fontSize: '12px',
        float: 'right',
        margin: '0 .25rem',
        padding: '.25rem 1rem',
        width: '120px',
        textAlign: 'center'
    },
    summaryContainer: {
        marginRight: '1rem'
    },
    summary: {
        color: '#fff',
        backgroundColor: cyan500,
        padding: '.25rem 1rem',
        borderRadius: '3px',
        fontSize: '12px',
        margin: '1rem .25rem',
        width: '120px',
        float: 'right',
        textAlign: 'center'
    }
};
var ListText = function (_a) {
    var item = _a.item;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, dayjs(item.date).format('YYYY-MM-DD')),
        React.createElement("span", { style: styles.textRight },
            "K\u00E9sz\u00FClts\u00E9g: ",
            item.progress,
            "%"),
        React.createElement("span", { style: styles.textRight },
            "Elt\u00F6lt\u00F6tt id\u0151: ",
            item.hours,
            " \u00F3ra")));
};
var TaskHistory = /** @class */ (function (_super) {
    tslib_1.__extends(TaskHistory, _super);
    function TaskHistory(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            history: {
                plannedDuration: 0.0,
                historyItems: []
            }
        };
        return _this;
    }
    TaskHistory.prototype.componentDidMount = function () {
        var _this = this;
        TaskApi.taskHistory(this.props.taskID).then(function (history) { return _this.setState({ history: history }); });
    };
    TaskHistory.prototype.render = function () {
        var history = this.state.history;
        if (!history || history.historyItems.length === 0) {
            return React.createElement("p", { style: { textAlign: 'center' } }, "Nincs adat");
        }
        var sum = history.historyItems.reduce(function (a, b) { return a + b.hours; }, 0.0);
        return (React.createElement(React.Fragment, null,
            React.createElement(List, null, history.historyItems.map(function (i) { return (React.createElement(React.Fragment, { key: i.id },
                React.createElement(ListItem, { primaryText: React.createElement(ListText, { item: i }), secondaryText: i.note || 'Nincs megjegyzés' }),
                React.createElement(Divider, null))); })),
            React.createElement("div", { style: styles.summaryContainer },
                React.createElement("div", { style: styles.summary },
                    "Tervezett id\u0151: ",
                    history.plannedDuration,
                    " \u00F3ra"),
                React.createElement("div", { style: styles.summary },
                    "\u00D6sszesen: ",
                    sum,
                    " \u00F3ra"))));
    };
    return TaskHistory;
}(React.Component));
export default TaskHistory;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskHistory.tsx
// module id = 775
// module chunks = 0